(function () {
    'use strict';

    angular.module("imApp").factory("shiftsService", ['$ihttp', function ($ihttp) {
        let service = {
            listShifts: function (parms) {
                return $ihttp.post({
                    method: 516,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
